"use client";

import {
  GuestOnlyPage,
  MobileAuthNotSupportedBanner,
  View,
} from "@/components";

import { GoogleAuthProvider } from "@/features";

import {
  LoginHeroBanner,
  LoginPageHeader,
  LoginPageContainer,
  LoginAuthenticationForm,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * LoginView Component
 *
 * Main login page with Google OAuth integration and responsive design.
 * Redirects authenticated users, shows different content for desktop/mobile.
 */
const LoginView = () => {
  return (
    <GuestOnlyPage redirectTo={"/"}>
      <GoogleAuthProvider>
        <View>
          <Flex direction={"column"}>
            {/* Navigation header */}
            <LoginPageHeader />

            {/* Main content area */}
            <LoginPageContainer>
              {/* Desktop marketing banner */}
              <LoginHeroBanner />

              {/* Login form */}
              <LoginAuthenticationForm />
            </LoginPageContainer>

            {/* Mobile restriction message */}
            {/* <MobileAuthNotSupportedBanner variant="login" /> */}
          </Flex>
        </View>
      </GoogleAuthProvider>
    </GuestOnlyPage>
  );
};

export { LoginView };
